"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createModifiers = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getUnit = function getUnit(value) {
  if (!value) {
    return;
  }

  if (typeof value === 'string') {
    return value;
  }

  return "".concat(value, "px");
};

var calculateOffset = function calculateOffset(_ref) {
  var moveBy = _ref.moveBy,
      placement = _ref.placement;

  /*
   * For `right` and `left` placements, we need to flip the `x` and `y` values as Popper.JS will use
   * the first value for the main axis. As per Popper.js docs:
   *
   *   if the placement is top or bottom, the length will be the width. In case of left or right, it
   *   will be the height.
   *
   */
  if (placement != null && placement.includes('right') || placement != null && placement.includes('left')) {
    return "".concat(moveBy ? moveBy.y : 0, "px, ").concat(moveBy ? moveBy.x : 0, "px");
  }

  return "".concat(moveBy ? moveBy.x : 0, "px, ").concat(moveBy ? moveBy.y : 0, "px");
};

var resolveWidth = function resolveWidth(_ref2) {
  var width = _ref2.width,
      minWidth = _ref2.minWidth,
      dynamicWidth = _ref2.dynamicWidth,
      referenceWidth = _ref2.referenceWidth;
  return {
    minWidth: dynamicWidth ? "".concat(referenceWidth, "px") : getUnit(minWidth),
    width: getUnit(width) || 'auto'
  };
};

var createModifiers = function createModifiers(_ref3) {
  var width = _ref3.width,
      moveBy = _ref3.moveBy,
      appendTo = _ref3.appendTo,
      shouldAnimate = _ref3.shouldAnimate,
      flip = _ref3.flip,
      fixed = _ref3.fixed,
      placement = _ref3.placement,
      isTestEnv = _ref3.isTestEnv,
      minWidth = _ref3.minWidth,
      dynamicWidth = _ref3.dynamicWidth;
  var preventOverflow = !fixed;
  var modifiers = {
    offset: {
      offset: calculateOffset({
        moveBy: moveBy,
        placement: placement
      })
    },
    computeStyle: {
      gpuAcceleration: !shouldAnimate
    },
    flip: {
      enabled: typeof flip !== 'undefined' ? flip : !moveBy
    },
    preventOverflow: {
      enabled: preventOverflow
    },
    hide: {
      enabled: preventOverflow
    }
  };

  if (dynamicWidth || minWidth || width) {
    modifiers.setPopperWidth = {
      enabled: true,
      order: 840,
      fn: function fn(data) {
        var referenceWidth = data.offsets.reference.width; // @ts-ignore

        data.styles = _objectSpread(_objectSpread({}, data.styles), resolveWidth({
          width: width,
          referenceWidth: referenceWidth,
          minWidth: minWidth,
          dynamicWidth: dynamicWidth
        }));
        return data;
      }
    };
  }

  if (isTestEnv) {
    modifiers.computeStyle = {
      enabled: false
    };
  }

  if (appendTo) {
    modifiers.preventOverflow = _objectSpread(_objectSpread({}, modifiers.preventOverflow), {}, {
      // @ts-ignore
      boundariesElement: appendTo
    });
  }

  return modifiers;
};

exports.createModifiers = createModifiers;
//# sourceMappingURL=modifiers.js.map